// src/api.js
import axios from 'axios';

const api = axios.create({
  // baseURL: 'http://localhost:3001/', // change as needed
  baseURL: 'https://www.snapcodetech.com/saitech/api/v1/', // change as needed
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;

export const getUsers = () => api.get('/users');

export const createUsers = (data) => api.post('/users', data);

export const deleteUsers = (id) => api.delete(`/users/${id}`);

export const updateUsers = (id, data) => api.put(`/users/${id}`, data);


export const getCategories = () => api.get('/categories');

export const createCategory = (data) => api.post('/categories', data);

export const deleteCategory = (id) => api.delete(`/categories/${id}`);

export const updateCategory = (id, data) => api.put(`/categories/${id}`, data);

export const getOrders = () => api.get('/orders');

export const getOrderByID = (id) => api.get(`/orders/${id}`);

export const createOders = (data) => api.post('/orders', data);

export const deleteOders = (id) => api.delete(`/orders/${id}`);

export const updateOrder = (id, data) => api.put(`/orders/${id}`, data);

export const getItems = () => api.get('/items');

export const getItemsByID = (id) => api.get(`/items/${id}`);

export const createItems = (data) => api.post('/items', data);

export const deleteItems = (id) => api.delete(`/items/${id}`);

export const updateItems = (id, data) => api.put(`/items/${id}`, data);

export const getCustomers = () => api.get('/customers');

export const createCustomers = (data) => api.post('/customers', data);

export const deleteCustomers = (id) => api.delete(`/customers/${id}`);

export const updateCustomers = (id, data) => api.put(`/customers/${id}`, data);